class CompareProductsResults extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.collection = this.getCollectionFromURL()

    if (this.collection) {
      this.refreshResults(this.collection)
    }
  }

  setupListeners () {
    super.setupListeners()
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.listeners.add(document, 'click', this.handleSelectChange)
  }

  getCompareList () {
    const stateEl = this.els.state.element

    const products = stateEl?.dataset.products || ''

    return products
      .split(',')
      .map((h) => h.trim())
      .filter(Boolean)
  }

  async handleSelectChange (event) {
    const option = event.target.closest(this.els.option.selector)
    if (!option || option.disabled) return

    const newHandle = option.dataset.handle
    const oldHandle = option.dataset.currentHandle || ''
    const collection = option.dataset.collection

    if (!newHandle || newHandle === oldHandle) return

    const compareKey = `compare-${collection}`

    const currentList = this.getCompareList()
    const nextList = [...currentList]

    if (oldHandle) {
      const index = currentList.indexOf(oldHandle)
      if (index === -1) return

      nextList[index] = newHandle
    } else {
      if (!nextList.includes(newHandle)) {
        nextList.push(newHandle)
      }
    }

    try {
      await window.BAO.Cart.updateCartAttributes({
        [compareKey]: nextList.join(','),
      })
    } catch (e) {
      console.error('Failed to update compare attribute:', e)
      return
    }

    await this.refreshResults(collection)
    window.drawers.activeDrawerKey = ''
  }

  async refreshResults (collection) {
    this.setAttribute('aria-busy', 'true')

    try {
      const res = await window.BAO.sectionRenderer.fetchSingle(
        'compare-products-results',
        `/collections/${collection}`,
      )

      const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
      const section = newDOM.querySelector('.shopify-section') || newDOM

      this.els.body.element.innerHTML = section.innerHTML
    } catch (e) {
      console.error('Failed to refresh results:', e)
    } finally {
      // 👇 always clear loading state
      this.removeAttribute('aria-busy')
    }
  }

  getCollectionFromURL () {
    const params = new URLSearchParams(window.location.search)
    return params.get('collection')
  }
}

if (!customElements.get('compare-products-results')) {
  customElements.define('compare-products-results', CompareProductsResults)
}
